import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import InputField from 'Components/Input/InputField';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import TextAreaField from 'Components/TextAreaField/TextAreaField';
import ComboBox from 'Components/ComboBox/ComboBox';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import MandatoryIconField from 'Components/MandatoryIconField';

const NewBenefitMonthPanel = ({
    itemInValidation,
    dsItem,
    currentMonth,
    idEmployee,
    showBenefitMonthPanel,
    onUpdatePanelCostSpreadsheet,
    onUpdateShowNewBenefitMonthPanel,
    onUpdateReloadSalaryBenefitsCost
}) => {
    const [idItemBenefit, setIdItemBenefit] = useState(null);
    const [valueBenefit, setValueBenefit] = useState(null);
    const [isRealValue, setIsRealValue] = useState(null);

    const [itemBenefitList, setItemBenefitList] = useState(null);
    const [employeesList, setEmployeesList] = useState(null);

    const [loadBenefitMonthPanel, setLoadBenefitMonthPanel] = useState(null);

    useEffect(() => {
        const onReady = async () => {
            await callToSetItemBenefitList(setItemBenefitList);
        };

        onReady();
    }, [])

    async function callToSetItemBenefitList() {
        const itemBenefitList = await ExecuteAxios.api('get', `/item-benefits/item-benefit-lookup`);
        setItemBenefitList(itemBenefitList);
    }
    const itemBenefitOptions = OptionsDataByAttributePath(itemBenefitList, ['dsItem'], null, true);

    useEffect(() => {
        const fetchData = async () => {
            const employeesList = await ExecuteAxios.api('get', '/benefits-month/lookup/employee/');
            setEmployeesList(employeesList);
        };

        fetchData();
    }, [showBenefitMonthPanel]);

    const employeeOptions = OptionsDataByAttributePath(employeesList, ['employeeName'], null, true)

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        alignItems: 'center'
    }

    function cancelFunction() {
        onUpdateShowNewBenefitMonthPanel(false);
        resetVariables();
    }

    function resetVariables() {
        setIdItemBenefit(null);
        setValueBenefit(null);
        setIsRealValue(null)
    }

    async function postFunction() {
        try {
            setLoadBenefitMonthPanel(true)
            const response = await ExecuteAxios.api('post', `/benefits-month/insert-benefits-month/`, {
                employeeId: idEmployee,
                itemBenefitId: idItemBenefit,
                valueBenefit, valueBenefit,
                isRealValue: isRealValue,
                currentMonth: currentMonth
            });

            if (response) {
                onUpdatePanelCostSpreadsheet(true)
                onUpdateReloadSalaryBenefitsCost(true)
                resetVariables();
                onUpdateShowNewBenefitMonthPanel(false)
            }

            return response;
        } finally {
            setLoadBenefitMonthPanel(false)
        }
    }

    const styleColumnAttributes = {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap'
    }

    const handleCheckboxChangeIsRealValue = (value) => {
        setIsRealValue(value === 'S' ? 'N' : 'S');
    };

    return (
        <MiddlePanel isVisible={showBenefitMonthPanel}>
            <LoadingIndicator loaded={!loadBenefitMonthPanel}>
                <Panel style={{
                    width: '450px',
                    height: '100%',
                    padding: '5px',
                    borderRadius: '10px',
                    backgroundColor: '#f5f5f5;',
                    border: '1px solid #ccc',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
                }}>
                    <Panel titlePage={'Novo benefício'}
                        style={panelListStyle}
                        canViewCRUD={true}
                        postFunction={postFunction}
                        canSaveAfterNewRecord={idEmployee && idItemBenefit && isRealValue}
                        cancelFunction={cancelFunction}
                        enableNewRecord={true}
                        canNewRecord={true}
                        enableDelete={true}
                        canDelete={true}
                        recordsSelected={[]}
                        inserting={true}>
                        <Panel style={styleButtonsMonth}>
                            <div style={styleColumnAttributes}>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Colaborador</label>
                                        <MandatoryIconField />
                                    </div>
                                    <ComboBox
                                        setAttribute={null}
                                        optionsData={employeeOptions}
                                        value={idEmployee}
                                        defaultValue={idEmployee}
                                        style={{ width: '200px', cursor: 'pointer' }}
                                        disabled={true}
                                    />
                                </div>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Benefício</label>
                                        <MandatoryIconField />
                                    </div>
                                    <ComboBox setAttribute={setIdItemBenefit}
                                        optionsData={itemBenefitOptions}
                                        style={{ width: '200px', cursor: 'pointer' }}
                                        value={idItemBenefit}
                                        defaultValue={idItemBenefit}
                                    />
                                </div>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Valor esperado</label>
                                    </div>
                                    <InputField
                                        setAttribute={setValueBenefit}
                                        value={valueBenefit}
                                        mask={'money'}
                                        readOnly={false}
                                        disabled={false}
                                        style={{ width: '200px', height: '35px' }}
                                    />
                                </div>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Valor real</label>
                                        <MandatoryIconField />
                                    </div>
                                    <InputField
                                        setAttribute={handleCheckboxChangeIsRealValue}
                                        value={isRealValue}
                                        mask={'money'}
                                        checked={isRealValue === 'S'}
                                        style={{ width: '200px', cursor: 'pointer' }}
                                        readOnly={false}
                                        disabled={false}
                                        type="checkbox"
                                    />
                                </div>
                            </div >
                        </Panel>
                    </Panel>
                </Panel>
            </LoadingIndicator>
        </MiddlePanel >
    );
}

export default NewBenefitMonthPanel;
